<template lang="pug">
v-dialog(:value="value" max-width="600px")
  v-card
    v-card-text
      .headline.pb-3.font-weight-bold How can I avoid my messages from being filtered by carriers?
      .headline.pb-2.font-weight-bold.primary-color No Reply? Hold Off!
      .pb-2 Multiple texts in a short period can be flagged as spam when you have received no response.
      .pb-3 Pro Tip: Wait 3 business days before a friendly follow-up offering additional value. This increases your chance of a positive response.
      .headline.pb-2.font-weight-bold.primary-color Text message content
      div.pb-2
        span.font-weight-bold Personalize texts as much as possible.
        span  Don’t forget to add your name and your company name.
      div.pb-2
        div.font-weight-bold Avoid spam triggers:
        ul
          li Avoid ALL CAPS
          li Avoid spammy words/symbols. Examples: free, risk-free, cash bonus, 100%, $
      div.pb-2
        span.font-weight-bold Full links
        span  "[yourcompany.com]"": Using shortened links (like bit.ly or goo.gl) raises red flags for carriers.
      div.pb-2
        span.font-weight-bold Avoid complicated financial jargon.
        span  Examples include "refinance," "loans," "mortgage rates," or "credit score." Say "see if you qualify for a lower rate" instead of "pre-approved refinance."
      div.pb-2
        span Any contact can report your texts as spam. Prevent spam flags by rewriting your messages to
        span.font-weight-bold  keep your contacts engaged.
    v-card-actions.justify-center
      v-btn(color='primary' @click="close") Close
      </template>

<script>
export default {
  name: 'Filtered Rates Info Modal',
  props: {
    value: Boolean,
  },
  methods: {
    close() {
      this.$emit('close');
    }
  },

};
</script>

<style lang="scss" scoped>
.primary-color {
  color: var(--v-primary-base) !important
}
</style>
